/* eslint-disable @next/next/no-img-element */
/**
 * /* eslint-disable @next/next/no-img-element
 *
 * @format
 */

import { Dropdown, Menu } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { graphQLClient, graphQLClientGET } from '~src/api/graphql'
import { GET_AVAILABLESTORES } from '~src/api/language'
import { useSetLanguage, useWindowSize } from '~src/hook'

const LanguageDropdown = () => {
  const queryClient = useQueryClient()
  const { dataLanguage, selectedLanguage, handleSelectedLanguage } = useSetLanguage()
  const { width } = useWindowSize()
  const items = dataLanguage?.map((language: TLanguage, index: number) => {
    return {
      key: index,
      label: '',
      icon: (
        <div
          className="w-full flex items-center gap-3  !bg-white hover:!bg-[#f5f5f5] duration-200 max-sm:justify-center max-sm:mr-0"
          key={`${language?.store_code}`}
          onClick={() => handleSelectedLanguage(language?.store_code)}
        >
          <div className="w-[2.2rem] h-[2.2rem] rounded-full overflow-hidden flex-shrink-0 max-sm:mx-auto">
            <img
              className="w-full h-full"
              src={language?.store_code === 'vi' ? '/image/svg/vietnam.svg' : '/image/english.png'}
              alt=""
            />
          </div>
          <span className="hidden sm:block text-[14px] whitespace-nowrap">
            {language?.store_name}
          </span>
        </div>
      ),
    }
  })

  if (width < 1200) {
    return null
  }

  return (
    <Dropdown
      placement="bottom"
      overlayClassName="drop-down-language"
      overlay={
        <Menu className="sm:flex flex-col items-center gap-[0.8rem]" items={items}>
          {/* {dataLanguage?.map((language: TLanguage) => {
              return (
                <Menu.Item
                  className="w-full"
                  key={`${language?.store_code}`}
                  onClick={() => handleSelectedLanguage(language?.store_code)}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-[22px] h-[22px]">
                      <img
                        className="rounded-full object-fill h-full w-full"
                        src={
                          language?.store_code === 'vi'
                            ? '/image/svg/vietnam.svg'
                            : '/image/english.png'
                        }
                        alt=""
                      />
                    </div>
                    <span className="hidden xs:block">{language?.store_name}</span>
                  </div>
                </Menu.Item>
              )
            })} */}
        </Menu>
      }
      trigger={['click']}
    >
      {selectedLanguage === 'en' ? (
        <button className="nation">
          <div className="img">
            <img src={'/image/english.png'} alt="" />
          </div>
          <span className="hidden xs:block">EN</span>
          <i className="fas fa-caret-down"></i>
        </button>
      ) : (
        <button className="nation">
          <div className="img">
            <img src={'/image/svg/vietnam.svg'} alt="" className="" />
          </div>
          <span className="hidden xs:block">VN</span>
          <i className="fas fa-caret-down"></i>
        </button>
      )}
    </Dropdown>
  )
}

export default LanguageDropdown
